import React from 'react';

const SMALL_DEVICE_BREAKPOINT = 1200;

export default function useSmallDevice() {
  const [isSmallDevice, setIsSmallDevice] = React.useState(false);

  React.useLayoutEffect(() => {
    const handleResize = () => {
      setIsSmallDevice(window.innerWidth < SMALL_DEVICE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isSmallDevice };
}



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/hooks/useSmallDevice.js